import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Timestamp } from 'firebase/firestore';
import { loadNotesFromStorage } from '../storageUtils.js';


const notesboardSlice = createSlice({


    name: "notesboard",
    initialState: loadNotesFromStorage() || {},
    /*
    {clubId : [
        {author: 
        timestamp: 
        message: 
        }
    ]
    }
     */
    reducers: {
        addNote(state, action){
            const clubId = action.payload.clubId
            if(!state[clubId])
                state[clubId] = [];

            const notesboard = state[clubId];
            const note = {
                noteId: action.payload.noteId,
                authorId: action.payload.userId,
                authorName: action.payload.username ?? null,
                profileImg: action.payload.profileImg,
                timestamp: action.payload.timestamp,
                message: action.payload.message ?? null
            }

            notesboard.push(note);

        },

        removeNote(state, action){
            
            const clubId = action.payload.clubId
            const noteIdRemove = action.payload.noteId
            console.log("clubId:", clubId)
            console.log("noteId to remove:", noteIdRemove)
            console.log("Current state[clubId]:", state[clubId])
            state[clubId] = state[clubId].filter(note => note.noteId !== noteIdRemove)

        },

        updateNotes(state, action){
            const { clubId, notes } = action.payload;
            const safeNotes = Array.isArray(notes) ? notes : [];
            console.log("notes froem friebase", safeNotes)
            state[clubId] = safeNotes;
            
    }

}})
export const {addNote, removeNote, updateNotes} = notesboardSlice.actions
export default notesboardSlice.reducer;